import { Toast, useToast } from '@zillow/constellation-10';

import { useCallback } from 'react';

type ToneType = 'info' | 'success' | 'warning' | 'critical' | undefined;
export const useBasicToast = () => {
    const { enqueueToast } = useToast();
    const toast = useCallback(
        (message: string, appearance: ToneType) => enqueueToast(<Toast tone={appearance}>{message}</Toast>),
        [enqueueToast]
    );
    return toast;
};
